import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { SplitterModule } from 'primeng/splitter';
import { SidebarComponent } from "./sidebar/sidebar.component";
import { TopbarComponent } from "./topbar/topbar.component";
import { PanelContenidoService } from '../shared/ui/services/panel-contenido.service';

@Component({
    selector: 'app-layout',
    imports: [
      CommonModule,
      RouterOutlet,
      SplitterModule,
      SidebarComponent,
      TopbarComponent
    ],
    standalone:true,
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.css'
})
export class LayoutComponent{

  @ViewChild('divPanelContenido') divPanelContenido!: ElementRef;

  showOutlet = true;

  constructor(private router: Router,
              private panelService: PanelContenidoService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.showOutlet = false;
      }
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.showOutlet = true, 0);
      }
    });
  }

}